/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Tabs } from "@mantine/core";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import {
  FaCartPlus,
  FaEdit,
  FaEnvelope,
  FaTrash,
  FaUser
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Halment from "../../faetures/Halment";
import {
  deleteUserMessage,
  deleteUserOrder,
  getMyInfo,
  getMyMessages,
  getMyOrder,
  updateProfile
} from "../../redux/actions/frontendActions/authenticationAction";
import OnlyFooter from "../common_components/OnlyFooter";
import Navbar from "../layout_components/Navbar";
function MyProfile() {
  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("first");

  const { myInfo, editProfile, editRequest, successMessage, loading , myMessages ,  myOrder ,  deleteMessageSuccess, deleteOrderSuccess} =
    useSelector((state) => state.Auth);

  useEffect(() => {
    dispatch(getMyInfo(myInfo.id));
  }, [myInfo.id]);

  useEffect(() => {
    if (editRequest) {
      setState({
        firstName: editProfile.firstName,
        lastName: editProfile.lastName,
        email: editProfile.email,
        phone: editProfile.phone,
      });
      dispatch({ type: "EDIT_REQUEST_CLEAR" });
    }
    if (successMessage) {
      toast.success(successMessage);
      window.location.reload();
    }
  }, [editProfile, successMessage]);

  const inputHendle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const update = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("firstName", state.firstName);
    formData.append("lastName", state.lastName);
    formData.append("email", state.email);
    formData.append("phone", state.phone);
    // formData.append("image", img.image)

    dispatch(updateProfile(editProfile._id, formData));
  };

  useEffect(() => {
    dispatch(getMyMessages(editProfile.email));
    dispatch(getMyOrder(editProfile.email));
    if(deleteMessageSuccess){
      toast.success(deleteMessageSuccess)

    }
    if(deleteOrderSuccess){
      toast.success(deleteOrderSuccess)
    
    }
  }, [editProfile.email ,deleteOrderSuccess , deleteMessageSuccess]);

  return (
    <>
      <Halment title="My Info" />
      <Navbar />

      <Toaster
        position={"bottom-center"}
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: "15px",
          },
        }}
      />

      <div className="my_info-top">
        <div className="margin_container">
          <Tabs value={activeTab} onTabChange={setActiveTab}>
            <div className="my-details-tab-area-wrapper">
              <div className="tabs-flex">
                <Tabs.List className="mantine-tabs-flex">
                  <Tabs.Tab value="first">
                    <FaUser /> Edit Profile
                  </Tabs.Tab>
                  <Tabs.Tab value="second">
                    <FaCartPlus /> My Order
                  </Tabs.Tab>
                  <Tabs.Tab value="third">
                    {" "}
                    <FaEnvelope /> My Messages
                  </Tabs.Tab>
                </Tabs.List>
              </div>
              <div className="items-wrapper">
                <Tabs.Panel value="first">
                  <div className="profile-edit-area">
                    <div className="edit-image-area">
                      <div style={{ display: "none" }} className="edit_icon">
                        <input required type="file" name="image" id="" />
                      </div>
                      <img src={editProfile.image} alt="" />
                      <FaEdit />
                    </div>
                    <div className="edit-input-area">
                      <form onSubmit={update}>
                        <div className="input-flex-in-edit-area">
                          <input
                          required
                            type="text"
                            placeholder="First Name"
                            onChange={inputHendle}
                            value={state.firstName}
                            name="firstName"
                          />
                          <input
                          required
                            type="text"
                            placeholder="Last Name"
                            onChange={inputHendle}
                            value={state.lastName}
                            name="lastName"
                          />
                        </div>
                        <div className="email-input">
                          <input
                          required
                            onChange={inputHendle}
                            value={state.email}
                            type="email"
                            name="email"
                            placeholder="your@gmail.com"
                            id=""
                          />
                        </div>
                        <div className="number-email">
                          <input
                          required
                            onChange={inputHendle}
                            value={state.phone}
                            name="phone"
                            type="number"
                            placeholder="phone number"
                            id=""
                          />
                        </div>
                        <div className="button-submit">
                          <Button type="submit">
                            {loading ? "Loading.." : " Edit Profile"}
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Tabs.Panel>
                <Tabs.Panel value="second">
                  <div className="profile-edit-area">
                    {
                       myOrder.length > 0?  myOrder.map((o ,i) =>   <div className="order-item-wrapper" key={i}>
                        <img src={o.image} alt="" />
                       <h4>{o.firstName} {o.lastName} </h4>
                       <h6>{o.email}</h6>   <img src={o.image} alt="" />
                       <h6>{o.phone}</h6>
                       <br />
                       <h2>Total: ${o.pPrice}</h2>
                       <h3>{o.pName}</h3>
                      
                       <h5>{o.pCategories}</h5>
                       <p>{o.createdAt}</p>
                       <h4 className="delete-item-form-my-info" onClick={() => dispatch(deleteUserOrder(o._id))}>
                         <FaTrash />
                         Cancel Order
                       </h4>
                     </div> ) : <h4>No Order yet</h4>
                    }
                  
                  </div>
                </Tabs.Panel>
                <Tabs.Panel value="third">
                  <div className="profile-edit-area">
                    <div className="message-flex-in-info">
                     
                      {
                        myMessages.length > 0 ? myMessages.map((m , i) => <div className="order-item-wrapper" key={i}>
                        <h4>{m.firstName} {m.lastName}</h4>
                        <img src={m.image} alt="" />
                        <h6>{m.email}</h6>
                        <br />
                        <p>
                         {m.message}
                        </p>
                        <h4 onClick={() => dispatch(deleteUserMessage(m._id))} className="delete-item-form-my-info">
                          <FaTrash /> Delete
                        </h4>
                        <h5>{m.createdAt}</h5>
                      </div>) : <h4>You've Sent No Message</h4>
                      }
                      
                     
                    </div>
                  </div>
                </Tabs.Panel>
              </div>
            </div>
          </Tabs>
          {}
        </div>
      </div>

      <OnlyFooter />
    </>
  );
}

export default MyProfile;
